import React from "react";
import { clearSelection } from "./clear-selection";
import { Platform } from "react-native";
export function useOnClickIndex(fn, index) {
    React.useEffect(() => {
        if (Platform.OS === "web") {
            const onKeyDown = (evt) => {
                console.log(evt.key);
                if (evt.key === (index + 1).toString() ||
                    (index === 0 &&
                        evt.key === "Enter")) {
                    fn();
                    clearSelection();
                }
            };
            window.addEventListener("keydown", onKeyDown);
            return () => {
                window.removeEventListener("keydown", onKeyDown);
            };
        }
    }, [fn, index]);
}
export function useOnAltClickIndex(fn, index) {
    React.useEffect(() => {
        if (Platform.OS === "web") {
            const onKeyDown = (evt) => {
                if (evt.altKey &&
                    evt.code.startsWith("Digit") &&
                    evt.code === "Digit" + (index + 1).toString()) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    fn();
                    clearSelection();
                }
            };
            window.addEventListener("keydown", onKeyDown);
            return () => {
                window.removeEventListener("keydown", onKeyDown);
            };
        }
    }, [fn, index]);
}
